import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../../../libs/styled.es.js';
import { SvgIcon } from '../../atoms/SvgIcon/SvgIcon.es.js';
import { Button } from '../../atoms/Button/Button.es.js';

const getTransform = (props) => {
    let style = '';
    switch (props.direction) {
        case 'right':
            style = 'transform: rotate(90deg)';
            break;
        case 'down':
            style = 'transform: rotate(180deg)';
            break;
        case 'left':
            style = 'transform: rotate(-90deg)';
            break;
    }
    return style;
};
const StyledIcon = styled(SvgIcon)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = styled(Button) `
  display: flex;
`;
const Text = styled.span `
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
    var { children, direction } = _a, props = __rest(_a, ["children", "direction"]);
    return (React.createElement(StyledButton, Object.assign({}, props),
        React.createElement(Text, null, children),
        React.createElement(StyledIcon, { direction: direction, name: "chevron-up", size: 12 })));
};

export { ButtonChevron };
